import { Component, OnInit, PLATFORM_ID, inject, DOCUMENT } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreRegionService } from '../../shared/services/store-region.service';
import { isPlatformBrowser, NgClass } from '@angular/common';
import { GoogleTagManagerService } from '../../shared/services/google-tag-manager.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { StateService } from '../../shared/services/storage/state.service';
import { environment } from 'src/environments/environment';
import { Language } from '../../shared/enum/Language';
// import { TranslateService } from '@ngx-translate/core';
import { PreferenceService } from '../../shared/services/preference/preference.service';
import { RegionRoutingService } from '../../shared/services/region-routing.service';
import { StoreCountry } from '../../shared/models/location.model';
import { LocalStorageVariables } from '../../shared/enum/localstorage-variables';
import { MatLabel, MatFormField } from '@angular/material/form-field';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-preference',
    templateUrl: './preference.component.html',
    styleUrls: ['./preference.component.scss'],
    standalone: true,
    imports: [MatLabel, MatFormField, MatSelect, FormsModule, ReactiveFormsModule, MatSelectTrigger, MatInput, MatOption, NgClass, MatButtonModule]
})
export class PreferenceComponent implements OnInit {
  private storeRegionService = inject(StoreRegionService);
  private googleTagManagerService = inject(GoogleTagManagerService);
  private localStorageService = inject(LocalStorageService);
  private stateService = inject(StateService);
  // private translateService = inject(TranslateService);
  private preferenceService = inject(PreferenceService);
  private regionRoutingService = inject(RegionRoutingService);
  private document = inject<Document>(DOCUMENT);

  filteredCountryList: StoreCountry[];
  selectedRegion: StoreCountry;
  storeRegionSelect: FormControl<StoreCountry> = new FormControl();
  languageControl: FormControl = new FormControl();
  searchedCountry = '';
  private countryList: StoreCountry[];
  private isBrowser: boolean;
  selectedLang: String = 'En';
  languageImage: any = '';
  languageCode: any = '';
  availableLanguages = [
    {
      code: 'en',
      str: 'English',
      img: '/images/icons/usa-flag.svg',
      primaryImage: '/images/icons/usa-primary-flag.png'
    },
    {
      code: 'ar',
      str: 'العربية',
      img: '/images/icons/uae-flag.svg',
      primaryImage: '/images/icons/uae-primary-flag.png'
    },
    {
      code: 'tr',
      str: 'Türkçe',
      img: '/images/icons/turkey-flag.svg',
      primaryImage: '/images/icons/turkey.png'
    }
  ];

  platformId = inject(PLATFORM_ID);
  constructor() {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.checkUserLanguage();
    this.initRegion();
    this.languageControl.disable();
  }

  initRegion() {
    this.filteredCountryList = this.countryList =
      this.storeRegionService.countryList;
    this.selectedRegion = this.storeRegionService.selectedRegion;
    if (!this.selectedRegion) {
      return;
    }
    this.storeRegionSelect.patchValue(
      this.filteredCountryList.find(
        (item) => item.id === this.selectedRegion.id
      ),
      { emitEvent: false }
    );
  }

  filterCountries() {
    const searchTextLower = this.searchedCountry.toLowerCase();
    this.filteredCountryList = this.countryList.filter((country) =>
      country.name.toLowerCase().includes(searchTextLower)
    );
  }

  clearSearchField() {
    this.searchedCountry = '';
    this.filteredCountryList = this.countryList;
  }

  discardPrefrences() {
    this.preferenceService.closePreference();
  }

  savePrefrences() {
    this.changeLanguage(this.languageControl.value.code);
    if (this.selectedRegion?.id != this.storeRegionSelect.value.id) {
      this.googleTagManagerService.sendAnalytics('change_region', {
        from: this.selectedRegion.code,
        to: this.storeRegionSelect.value.code
      });

      const previousRegion = this.selectedRegion;
      const newRegion = this.storeRegionSelect.value;

      this.storeRegionService.setRegion(newRegion);

      this.selectedRegion = newRegion;
    }
    this.preferenceService.closePreference();
  }

  checkUserLanguage() {
    let userLang;
    if (this.isBrowser) {
      userLang = this.localStorageService.getItem(
        LocalStorageVariables.user_lang
      );
    }

    if (userLang) {
      this.changeLanguage(userLang, true);
    } else {
      this.changeLanguage(environment.defaultLang, true);
    }
  }

  changeLanguage(lang: any, isInitial?: boolean) {
    if (!isInitial) {
      this.googleTagManagerService.sendAnalytics('change_language', {
        from: this.stateService.userLanguage.value,
        to: lang
      });
    }
    let languageObject = this.availableLanguages.find(
      (obj) => obj?.code === lang
    );
    this.languageControl.patchValue(languageObject);
    this.languageImage = languageObject.primaryImage;
    this.languageCode = languageObject.str;
    if (this.isBrowser) {
      this.localStorageService.setItem(LocalStorageVariables.user_lang, lang);
    }
    this.stateService.setLanguageStatus(lang);
    this.selectedLang = Language[lang];
    let htmlTag = this.document.getElementsByTagName(
      'html'
    )[0] as HTMLHtmlElement;
    if (lang === 'fa' || lang == 'ar') {
      htmlTag.dir = 'rtl';
    } else {
      htmlTag.dir = 'ltr';
    }
    // this.translateService.setFallbackLang(lang);
    // this.translateService.use(lang);
  }
}
